export default {
	roles: [
		{ id: 0, text: "אדמין", rule: "admin" },
		{ id: 1, text: "לקוח", rule: "customer" },
	],
	rules: {
		admin: { route: "admin", baseUrl: "/api/admin" },
		customer: { route: "customer", baseUrl: "/api" },
	},
};
